/* eslint-disable import/prefer-default-export */
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export const sendError = (errorEvent, data, errorText) => {
  Sentry.withScope(scope => {
    if (data) scope.setExtra('data', data);
    if (errorText) scope.setTag('error-type', errorText);
    Sentry.captureException(errorEvent);
  });
};

const SENTRY_KEY = process.env.REACT_APP_SENTRY_KEY;

// eslint-disable-next-line import/no-mutable-exports
export let sendTextError = (...args) => console.log(...args);

export const configSentry = config => {
  Sentry.configureScope(scope => scope.setUser(config));
};

// https://rainforest-life.atlassian.net/browse/SM-6124
const handleNotAvailableJsChunk = (event, hint) => {
  const error = hint?.originalException;
  const isChunkLoadError = error?.message?.includes('Unexpected token <');
  if (!isChunkLoadError) return false;
  const maxRetries = 3;
  const retryDelay = 500; // ms
  const attempts = +sessionStorage.getItem('cra_reload_attempts') || 0;
  if (attempts >= maxRetries) return false;
  sessionStorage.setItem('cra_reload_attempts', attempts + 1);
  console.warn(`Retrying reload #${attempts + 1} due to chunk load failure`);
  setTimeout(() => {
    window.location.reload(true);
  }, retryDelay * attempts);
  return true;
};

const beforeSend = (event, hint) => {
  if (handleNotAvailableJsChunk(event, hint)) return null;
  return event; // Allow Sentry to send the event
};

export const initSentry = (store, addSentSentryErrorTypeAction) => {
  if (!SENTRY_KEY) return;
  Sentry.init({
    dsn: SENTRY_KEY,
    release: process.env.REACT_APP_VERSION,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    beforeSend
  });
  sendTextError = (errorText, data) => {
    const state = store.getState();
    const { sentErrorsTypes } = state.sentry;
    if (sentErrorsTypes?.includes(errorText)) return;
    store.dispatch(addSentSentryErrorTypeAction(errorText));
    Sentry.withScope(scope => {
      if (data) scope.setExtra('data', data);
      if (data?.url) scope.setTag('request-url', data?.url);
      if (data?.status) scope.setTag('request-status', data?.status);
      Sentry.captureMessage(errorText);
    });
  };
};

const RESTRICTED_FIELD_NAMES = [
  'token',
  'email',
  'username',
  'mwstoken',
  'sellerid',
  'companyname',
  'address',
  'taxid'
];

const isRestrictedFieldName = fieldName =>
  RESTRICTED_FIELD_NAMES.find(restrictedName =>
    fieldName
      ?.toLowerCase()
      ?.replaceAll('_', '')
      ?.includes(restrictedName)
  );

export const getFilteredRequestData = requestData => {
  if (!requestData) return requestData;
  try {
    const parsedRequestData = JSON.parse(requestData);
    Object.keys(parsedRequestData).forEach((key, i) => {
      if (isRestrictedFieldName(key)) {
        delete parsedRequestData[key];
        const newKey = key.toLowerCase().replace('key', `key-${i}`);
        parsedRequestData[newKey] = 'restricted key was here';
      }
    });
    return JSON.stringify(parsedRequestData);
  } catch (e) {
    return requestData;
  }
};
